type Props = {
  id?: string;
  children?: React.ReactNode;
};

function Details({ id, children }: Props) {
  return (
    <div id={id} className="details">
      {children}
    </div>
  );
}

export default Details;
